import {getEntryPoint, getResponseUrl} from '../util/entrypoint';

export const entrypoint = getEntryPoint();
export const responseUrl = getResponseUrl();